import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=df381a82&scoped=true"
import script from "./AddDialog.vue?vue&type=script&lang=js"
export * from "./AddDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=df381a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df381a82",
  null
  
)

export default component.exports